<template>
  <div class="container">
    <div class="main">
      <div class="title">
        <p class="head">主營業務</p>
        <p class="sub">Main Business</p>
      </div>
      <div class="item"
           v-for="(item,index) in mainData"
           :key="index">
        <img :src="require(`../../assets/image/mobile/service${index+1}.png`)"
             alt="">
        <p class="name">{{item.title}}</p>
        <div :class="['con',{'con-active':item.active}]">
          <p @click="mainSwitch(index)">{{item.active?item.allCon:item.con}}</p>
          <div class="switch"
               v-if="!item.active"
               @click="mainSwitch(index)">
            {{item.active?'收起':'展開'}} <img src="../../assets/image/mobile/down-icon.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="other">
      <div class="title">
        <p class="head">其他業務</p>
        <p class="sub">Other Business</p>
      </div>
      <div class="item"
           v-for="(item,i) in otherData"
           :key="i">
        <div class="top">
          <span class="name">{{item.title}}</span>
          <img :src="require(`../../assets/image/mobile/service-icon${i+1}.png`)"
               alt="">
        </div>
        <div :class="['con',{'con-active':item.active}]">
          <p @click="otherSwitch(i)">
            {{item.active?item.allCon:item.con}}
          </p>
          <div class="switch"
               v-if="!item.active"
               @click="otherSwitch(i)">
            {{item.active?'收起':'展開'}} <img src="../../assets/image/mobile/down-icon.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mainData: [
        {
          title: '外賣業務',
          active: false,
          con:
            '澳覓的核心業務之一，通過高頻、剛需、量大的餐飲業務切入市場，上線初期就深受用戶喜愛。目前合作商戶超過1600家，月銷售額超過3000萬，市場佔有率達到90%左右。為滿足商家需求......',
          allCon:
            '澳覓的核心業務之一，通過高頻、剛需、量大的餐飲業務切入市場，上線初期就深受用戶喜愛。目前合作商戶超過1600家，月銷售額超過3000萬，市場佔有率達到90%左右。為滿足商家需求，澳覓致力於推廣智能SaaS餐飲管理系統，加速餐飲信息化升級。同時，為打造澳門“最後一公里”即時配送能力，澳覓有著一隻300多人配送團隊，是目前澳門最大的同城即時物流配送團隊。'
        },
        {
          title: '团购業務',
          active: false,
          con:
            '澳覓團購業務幾乎覆蓋了全澳的吃喝玩樂，主要有餐飲團購，自助餐，休閒娛樂，美容美髮等內容，目前已有400家商家合作，並不斷有新的合作夥伴加入。最高峰時期，澳覓線上當天一共有7萬用戶同時參......',
          allCon:
            '澳覓團購業務幾乎覆蓋了全澳的吃喝玩樂，主要有餐飲團購，自助餐，休閒娛樂，美容美髮等內容，目前已有400家商家合作，並不斷有新的合作夥伴加入。最高峰時期，澳覓線上當天一共有7萬用戶同時參與參與搶購。澳覓將不斷推动本地生活市场的数字化，让线下没有难做的生意。'
        },
        {
          title: '線上超市業務',
          active: false,
          con:
            '澳覓超市上線於2020年9月，主打“澳覓乜都有，新鮮送到手”。澳覓網上超市是澳覓APP旗下自營超市平台，是一個圍繞澳門本地居民日常生活和餐桌所需食材及配套的全品類購物平台，我們通過與境內外大型優質供應商的合......',
          allCon:
            '澳覓超市上線於2020年9月，主打“澳覓乜都有，新鮮送到手”。澳覓網上超市是澳覓APP旗下自營超市平台，是一個圍繞澳門本地居民日常生活和餐桌所需食材及配套的全品類購物平台，我們通過與境內外大型優質供應商的合作，努力為您提供安心安全的商品和服務，所經營的品類涵蓋了水果、蔬菜、肉禽蛋、冰鮮水產、冷藏急凍和常溫標品等分類的商品。澳覓網上超市將通過自己的供應鏈和倉配優勢，將訂單所需的新鮮食材送貨到家、到手，努力化解您買菜的尷尬，讓您足不出戶、上下班途中、甚至遠在異響也可以通過指尖的簡單操作就能實現所見即所得的到家服務。澳覓網上超市提供的高效便捷購物服務，讓您有更多的時間去陪伴家人和享受生活，重燃在家做飯的熱情。澳覓網上超市服務：讓鮮美食材變得“觸手”可得，方便千家萬戶一日三餐；我們的願景是成為全澳最大最值得信任的家庭食材食品運營和銷售商。'
        },
        {
          title: '物流業務',
          active: false,
          con:
            '松鼠物流是澳覓APP旗下專業物流服務公司。組建了一支300+的配送隊伍，建立了非常高效的即時物流及規劃物流服務，具備兩地物流轉運能力。松鼠物流能夠滿足日單量1-1.5萬件的澳門本地及時達配送需求......',
          allCon:
            '松鼠物流是澳覓APP旗下專業物流服務公司。組建了一支300+的配送隊伍，建立了非常高效的即時物流及規劃物流服務，具備兩地物流轉運能力。松鼠物流能夠滿足日單量1-1.5萬件的澳門本地及時達配送需求。松鼠宅配業務實現了顧客在國內電商平臺購物，在澳門無憂送貨上門服務。該業務在珠海自建倉庫，能夠承載1萬單/日容量，在澳門自建轉運倉，能夠承載1.5萬單/日。'
        },
      ],
      otherData: [
        {
          title: '創意營銷',
          active: false,
          con:
            '澳覓品牌業務為澳門本地上千間餐飲行業門店提供創新营销模式，根據商家自身經營狀況和運營模式，提出合理化方針，提升營運效率，幫助商家節約營運成本，增加......',
          allCon:
            '澳覓品牌業務為澳門本地上千間餐飲行業門店提供創新营销模式，根據商家自身經營狀況和運營模式，提出合理化方針，提升營運效率，幫助商家節約營運成本，增加營運收入 。在品牌創意方面，澳覓提供品牌升級服務，包括但不僅限於品牌環境調研、品牌定位、品牌設計、品牌推廣策略等方面，以提升客戶品牌的市場影響力。'
        },
        {
          title: '社交媒體運營',
          active: false,
          con:
            '由澳覓專業內容營銷團隊為澳門20餘個局級政府部門服務，致力於內容方案諮詢、社交媒體矩陣搭建、內容輸出、大數據分析和管理等服務，提供多元化、專業的社交媒體運營管理......',
          allCon:
            '由澳覓專業內容營銷團隊為澳門20餘個局級政府部門服務，致力於內容方案諮詢、社交媒體矩陣搭建、內容輸出、大數據分析和管理等服務，提供多元化、專業的社交媒體運營管理和優化方針。如：為澳門氣象局開通、認證及技術支持，接入惡劣天氣自動推送系統；為市政署開通及認證微信公眾號，向市民分享市政署最新消息和活動提供管道；為中葡經貿論壇開通及認證微信公眾號，向海內外企業公眾及部門機關傳遞政務資訊。'
        },
        {
          title: '技術服務',
          active: false,
          con:
            '澳覓科技業務由專業的研發人員組成，以技術服務為基礎，為企業提供大數據分析、優質有效的行業解決方案以及技術產品優化。包括但不僅限於網站製作、APP製作以及維護、H5互......',
          allCon:
            '澳覓科技業務由專業的研發人員組成，以技術服務為基礎，為企業提供大數據分析、優質有效的行業解決方案以及技術產品優化。包括但不僅限於網站製作、APP製作以及維護、H5互動頁面、支付系統、票務系統、收銀系統等全方位技術服務。通過產品和服務，幫助互聯網時代的生意人私有化顧客資產、拓展互聯網客群、提高經營效率，全面助力企業商戶成功。澳覓技術團隊樂於探索，勇於創新，對於新鮮技術保持著持續的敏感。 2019年為澳門金沙提供支付技術解決方案，獲得業界好評如潮。'
        },
        {
          title: '商家服務',
          active: false,
          con:
            '澳覓商家服務團隊由澳覓創立之初就已成立，以微信，Facebook，電話，郵件等多種方式受理商家業務諮詢、投訴申告、業務受理等多樣化的服務需求。團隊堅持以100％受......',
          allCon:
            '澳覓商家服務團隊由澳覓創立之初就已成立，以微信，Facebook，電話，郵件等多種方式受理商家業務諮詢、投訴申告、業務受理等多樣化的服務需求。團隊堅持以100%受理、100%處理、100%回覆、100%滿意的服務準則提高團隊工作整體質量及商家滿意度。通過建立客服專員服務，設置專項服務內容，確保澳覓的商家問題在約定期限內得到答復，實現承諾性服務和一站式高效優質的服務。'
        }
      ]
    }
  },
  methods: {
    mainSwitch(i) {
      this.mainData[i].active = !this.mainData[i].active
    },
    otherSwitch(i) {
      this.otherData[i].active = !this.otherData[i].active
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  line-height: 1;
  text-align: left;
  background-color: #2c2b38;
  .main {
    padding: 0 20px 30px;
    font-size: 13px;
    color: #2d2f3c;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    background-color: #fff;
    .title {
      padding-top: 30px;
      .head {
        font-size: 18px;
        font-weight: bold;
      }
      .sub {
        font-size: 11px;
        color: #ff3159;
        padding-top: 5px;
      }
    }
    .item {
      margin-top: 25px;
      transform: all 0.3s ease;
      > img {
        width: 335px;
        margin: auto;
      }
      > p {
        font-size: 15px;
        font-weight: bold;
        padding-top: 14px;
      }
      .con {
        position: relative;
        padding-top: 2px;
        line-height: 1.8;
        .switch {
          position: absolute;
          right: 0;
          bottom: -18px;
          display: flex;
          align-items: center;
          color: #ff3159;
          img {
            width: 10px;
            padding-left: 5px;
          }
        }
      }
      .con-active {
        .switch {
          img {
            transform: rotate(180deg);
            padding-right: 5px;
          }
        }
      }
    }
  }
  .other {
    padding: 0 20px 35px;
    font-size: 13px;
    .title {
      padding-top: 30px;
      .head {
        font-size: 18px;
        font-weight: bold;
        color: #fff;
      }
      .sub {
        font-size: 11px;
        color: #ff3159;
        padding-top: 5px;
      }
    }
    .item {
      position: relative;
      margin-top: 35px;
      padding: 30px 20px;
      transform: all 0.3s ease;
      background-color: #3c456c;
      border-radius: 5px;
      .top {
        .name {
          position: relative;
          font-size: 15px;
          font-weight: bold;
          color: #fff;
          z-index: 1;
          &::after {
            position: absolute;
            left: 0;
            top: 15px;
            content: '';
            width: 100%;
            height: 5px;
            background: linear-gradient(to bottom right, #fd3159, #7f2a42);
            z-index: -1;
          }
        }
        img {
          position: absolute;
          right: 22px;
          top: -20px;
          width: 83px;
        }
      }
      .con {
        position: relative;
        padding-top: 27px;
        line-height: 1.8;
        color: #fff;
        .switch {
          position: absolute;
          right: 0;
          bottom: -18px;
          display: flex;
          align-items: center;
          color: #ff3159;
          font-size: 13px;
          img {
            width: 10px;
            padding-left: 5px;
          }
        }
      }
      .con-active {
        .switch {
          img {
            transform: rotate(180deg);
            padding-right: 5px;
          }
        }
      }
    }
  }
}
</style>